import { ArrowBackRounded } from '@mui/icons-material';
import {
  Button, Container, FormHelperText, IconButton, TextField, Grid, CircularProgress, Snackbar, Alert,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { otpVerif, resendOTP } from '../../../../Redux/Models/auth';
import { onlyNumbers } from '../../../../Utils/helpers';
import { getToken } from '../../../../Utils/storages';

export default function OTP({
  classes, error, message, isLoading,
  resendOtpSuccess,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [otp, setOtp] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [resent, setResent] = useState(false);

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleChangeOTP = (e) => {
    const val = e.target.value;
    if (val && val.length <= 6) {
      setOtp(onlyNumbers(e.target.value));
    } else if (!val) setOtp('');
  };

  useEffect(() => {
    if (!location.state) {
      navigate(ROUTES.signin());
    }
  }, [location]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    dispatch(otpVerif({ otp_code: otp?.toString() }, location.state?.email));
  };

  const resendOtp = async () => {
    await dispatch(resendOTP(location.state));
    setResent(true);
  };

  useEffect(() => {
    if (resent && resendOtpSuccess) {
      setSnackbar({
        open: true,
        severity: 'success',
        message: 'OTP has been sent. Please check your email!',
      });
    }
    if (resent && !resendOtpSuccess) {
      setSnackbar({
        open: true,
        severity: 'error',
        message: `Something went wrong: ${message}`,
      });
    }
  }, [resent, resendOtpSuccess]);

  const token = getToken();
  useEffect(() => {
    if (token) {
      window.location.reload();
    }
  }, [token]);

  const showError = submitted && error;

  if (token) { return null; }

  return (
    <div className={classes.root}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={12} sm={10} md={6} lg={4}>
          <Container sx={{ py: 5, minHeight: '100vh', position: 'relative' }} maxWidth="sm">
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackRounded />
            </IconButton>
            <div className="center">
              <h1>
                <img src={Images.Logo} alt="Boxpack" height={65} />
              </h1>
              <h3 className="mt-6 s-16">OTP Verification</h3>

              <div className="height-14 mt-1 desc center">
                To continue,
                <br />
                please input your OTP that
                <br />
                we have sent to your email
              </div>
            </div>
            <form onSubmit={handleSubmit} className="mt-6">

              <div className="mt-4">
                <label htmlFor="otp">OTP</label>
                <TextField
                  type="otp"
                  size="small"
                  id="otp"
                  required
                  name="otp"
                  placeholder="123456"
                  fullWidth
                  autoComplete="off"
                  value={otp}
                  onChange={handleChangeOTP}
                  InputProps={{
                    autoComplete: 'new-password',
                  }}
                />
                {showError
                && <FormHelperText error>{message || 'Something went wrong'}</FormHelperText>}
              </div>

              <div className="action">
                <Container sx={{ pb: 4 }}>
                  <div>
                    <Button disabled={isLoading} startIcon={isLoading && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)} size="large" type="submit" variant="contained" className="btn-contained" fullWidth>Confirm</Button>
                  </div>

                  <div className="center mt-5">
                    <div className="height-14 weight-600">
                      Didn&apos;t receive OTP?
                      {' '}
                      <span className="link weight-700" onClick={resendOtp}>Resend OTP</span>
                    </div>
                  </div>
                </Container>
              </div>

            </form>
          </Container>
        </Grid>
      </Grid>
    </div>
  );
}
